import { emptyResearchState, type ResearchState } from './types'
import { sanitizeResearchState } from './purchase'

export const RESEARCH_STORAGE_KEY = 'shapes-td.research.v1'

export function createResearchStorage(storage?: Storage) {
  const resolve = (): Storage | null => {
    if (storage) return storage
    if (typeof localStorage === 'undefined') return null
    return localStorage
  }

  return {
    load(): ResearchState {
      const backend = resolve()
      if (!backend) return emptyResearchState()
      try {
        const raw = backend.getItem(RESEARCH_STORAGE_KEY)
        if (!raw) return emptyResearchState()
        return sanitizeResearchState(JSON.parse(raw) as unknown)
      } catch {
        return emptyResearchState()
      }
    },

    save(state: ResearchState): void {
      const backend = resolve()
      if (!backend) return
      try {
        backend.setItem(RESEARCH_STORAGE_KEY, JSON.stringify(state))
      } catch {
        // quota / private mode
      }
    },

    clear(): void {
      const backend = resolve()
      if (!backend) return
      try {
        backend.removeItem(RESEARCH_STORAGE_KEY)
      } catch {
        // ignore
      }
    }
  }
}

export const researchStorage = createResearchStorage()
